const eurFmt = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });

export const fmtEur = (n) => eurFmt.format(Number(n || 0));
export const fmtPct = (n) => `${Number(n || 0).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} %`;
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR") : "—");

export const MOIS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
export const YEARS = [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027];

export const STATUS_LABELS = { brouillon: "Brouillon", validee: "Validée", teletransmise: "Télétransmise", payee: "Payée" };
export const STATUS_CLASSES = {
  brouillon: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-muted dark:text-muted-foreground dark:border-border",
  validee: "bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/15 dark:text-brand-300 dark:border-brand-500/40",
  teletransmise: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/40",
  payee: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/40",
};
export const TYPE_LABELS = { mensuelle: "Mensuelle (2501)", trimestrielle: "Trimestrielle (2501)", annuelle: "Annuelle (2502)" };
export const ZONE_LABELS = { metropole: "Métropole", dom_295: "Guadeloupe / Martinique / Réunion (2,95 %)", dom_255: "Guyane / Mayotte (2,55 %)" };
export const BRACKET_COLORS = ["#7161D0", "#D97706", "#DC2626"];

export const monthKey = (year, m) => `${year}-${String(m).padStart(2, "0")}`;
